var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14.239V15.375H3.76104C4.68073 15.375 5.14058 15.375 5.55406 15.2037C5.96755 15.0325 6.2927 14.7073 6.94302 14.057L14.341 6.65901C15.0029 5.99709 15.3338 5.66612 15.3704 5.25994C15.3765 5.19279 15.3765 5.12523 15.3704 5.05808C15.3338 4.6519 15.0029 4.32093 14.341 3.65901C13.679 2.99709 13.3481 2.66612 12.9419 2.62954C12.8747 2.62349 12.8072 2.62349 12.74 2.62954C12.3338 2.66612 12.0029 2.99709 11.341 3.65901L3.94302 11.057C3.2927 11.7073 2.96755 12.0325 2.79627 12.446C2.625 12.8594 2.625 13.3193 2.625 14.239Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 4.875L13.125 7.875",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ebcb7d3f250d3e8778f162157bcaeca6.svg";
export { ForwardRef as ReactComponent };